module.exports = __webpack_public_path__ + "img/xingxing.d97017f4.png";